import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {Link, browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {default as Spinner, SIZE_LARGE} from 'components/Spinner';
import {Request, GET, DELETE} from 'requests';
import {ResourcesMatching, Requesting, Done} from 'requests/components';
import {default as RequestsMixin, IS_DONE} from 'requests/RequestsMixin';
import Header from './Header';
import ImagePreview from './ImagePreview';
import EditImageForm from './EditImageForm';

const mapStateToProps = (state, ownProps) => {
  const kitToken = ownProps.params.kitToken;
  const workingSetImageId = ownProps.params.workingSetImageId;

  return {
    requests: state.requests,
    kitToken,
    workingSetImageId,
  };
};

const EditImageController = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    requests: PropTypes.object.isRequired,
    kitToken: PropTypes.string.isRequired,
    workingSetImageId: PropTypes.string.isRequired,
  },

  mixins: [RequestsMixin, ImmutableRenderMixin],

  componentWillMount() {
    this.setRequest({
      kit: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken],
      }),
    });

    this.setRequest({
      workingSetImage: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'working-set-images', this.props.workingSetImageId],
      }),
    });
  },

  transitions(register) {
    register({
      request: this.requests.deleteWorkingSetImage,
      to: IS_DONE,
      call(rm) {
        browserHistory.push(`/kits/${this.props.kitToken}/images`);
      },
    });
  },

  resources() {
    const rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').get(),
      workingSetImage: rm.type(this.requests.workingSetImage, 'working-set-images').get(),
    };
  },

  handleDeleteWorkingSetImage(workingSetImage) {
    this.setRequest({
      deleteWorkingSetImage: new Request({
        url: ['api', 'kits', this.props.kitToken, 'working-set-images', workingSetImage.id],
        method: DELETE,
        record: workingSetImage,
      }),
    });
  },

  handleWorkingSetImageUpdated() {
    browserHistory.push(`/kits/${this.props.kitToken}/images`);
  },

  renderMain() {
    const {
      kit,
      workingSetImage,
    } = this.resources();
    const formElement = (workingSetImage) ?
      <EditImageForm
        kitToken={kit.token}
        workingSetImage={workingSetImage}
        onDeleteWorkingSetImage={this.handleDeleteWorkingSetImage}
        onSuccess={this.handleWorkingSetImageUpdated}
      /> : null;
    const previewElement = (workingSetImage) ?
      <ImagePreview
        kitToken={kit.token}
        workingSetImage={workingSetImage}
      /> : null;

    return (
      <div className="well bg-white will-fill-page p-xs-a-lg">
        <Link to={`/kits/${kit.token}/images`} className="link-dashed-none">&lsaquo; Back to {kit.name}</Link>

        <Header kit={kit} heading="Edit / View Image" headingIcon="ficon-pencil" />

        <div className="row">
          <div className="col-xs-6">
            {formElement}
          </div>
          <div className="col-xs-6 image-asset-preview-rendering">
            {previewElement}
          </div>
        </div>
      </div>
    );
  },

  renderSpinner() {
    return (
      <div className="well bg-white will-fill-page p-xs-a-lg is-loading">
        <Spinner size={SIZE_LARGE} />
      </div>
    );
  },

  render() {
    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <Requesting any={true} render={this.renderSpinner} />
        <Done all={true} render={this.renderMain} />
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(EditImageController);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/EditImageController.js